import { color } from "@smartsheet/design-tokens-react";
import { ChipColorVariant, SemanticChipStatus } from "../types";

export const chipCustomCssProperties = {
    text: `--smar--core--chip--text`,
    backgroundRest: `--smar--core--chip--background--rest`,
    backgroundHover: `--smar--core--chip--background--hover`,
    backgroundActive: `--smar--core--chip--background--active`,
};

/**
 * A mapping of the semantic chip status or chip color to the corresponding token name.
 */
export const tokenMap = {
    neutral: "neutral",
    aqua: "aqua",
    azure: "azure",
    blue: "blue",
    gold: "gold",
    green: "green",
    indigo: "indigo",
    mint: "mint",
    orange: "orange",
    orchid: "orchid",
    pink: "pink",
    red: "red",
    rose: "rose",
    slate: "slate",
    teal: "teal",
    violet: "violet",
    yellow: "yellow",
};

const semanticTokenMap = {
    "in-progress": "semantic--info",
    completed: "semantic--success",
    "at-risk": "semantic--warning",
    blocked: "semantic--error",
} as const;

const isSemanticColor = (color: SemanticChipStatus | ChipColorVariant): color is SemanticChipStatus =>
    color in semanticTokenMap;

interface GetTokenForColorResult {
    backgroundActive: Parameters<typeof color>[0];
    backgroundHover: Parameters<typeof color>[0];
    backgroundRest: Parameters<typeof color>[0];
    text: Parameters<typeof color>[0];
}

export const getTokenForColor = (color: SemanticChipStatus | ChipColorVariant): GetTokenForColorResult => {
    // Not-started remaps to neutral.
    if (color !== "not-started" && isSemanticColor(color)) {
        const semanticMapping = semanticTokenMap[color];
        return {
            text: `${semanticMapping}--text` as const,
            backgroundRest: `${semanticMapping}--background` as const,
            backgroundHover: `${semanticMapping}--background--hover` as const,
            backgroundActive: `${semanticMapping}--background--active` as const,
        };
    } else {
        if (color === "not-started") {
            color = "neutral";
        }
        return {
            text: `${color}--text` as const,
            backgroundRest: `${color}--background-alt` as const,
            backgroundHover: `${color}--background-alt--hover` as const,
            backgroundActive: `${color}--background-alt--active` as const,
        };
    }
};
